<template>
  <div class="content">
    <div class="row text-left">
      <div class="col-md-2">
        <b class="text-black-50">
          Категории комплектующих и материалов
        </b>
      </div>
      <div class="col-md-10">
        <p class="text-black-50">
          Новая категория
          <i v-on:click="newProductCategory" class="tim-icons icon-book-bookmark"></i>
        </p>
      </div>
    </div>
    <big-one :content="productCategory" :type = "'productCategory'" :tuning="false"
             :new-one="newPC" @resetNew="newPC = null"></big-one>

    <div class="row text-left">
      <div class="col-md-2">
        <b class="text-black-50">
          Категория инвалида
        </b>
      </div>
      <div class="col-md-10">
        <p class="text-black-50">
          Новая категория
          <i v-on:click="newDisabledCategory" class="tim-icons icon-book-bookmark"></i>
        </p>
      </div>
    </div>
    <big-one :content="disabledCategory" :type = "'disabledCategory'" :tuning="false"
             :new-one="newDC" @resetNew="newDC = null"></big-one>

    <div class="row text-left">
      <div class="col-md-2">
        <b class="text-black-50">
          Групппа инвалидности
        </b>
      </div>
      <div class="col-md-10">
        <p class="text-black-50">
          Новая группа
          <i v-on:click="newGroup" class="tim-icons icon-book-bookmark"></i>
        </p>
      </div>
    </div>
    <big-one :content="group" :type = "'group'" :tuning="false"
             :new-one="newG" @resetNew="newG = null"></big-one>

    <div class="row text-left">
      <div class="col-md-2">
        <b class="text-black-50">
          Типы работ
        </b>
      </div>
      <div class="col-md-10">
        <p class="text-black-50">
          Новый тип
          <i v-on:click="newWorkType" class="tim-icons icon-book-bookmark"></i>
        </p>
      </div>
    </div>
    <big-one :content="workType" :type = "'workType'" :tuning="false"
             :new-one="newWT" @resetNew="newWT = null"></big-one>
  </div>
</template>
<script>

export default{
  data() {
    return {
      productCategory: [{header: "Наименование", name: "name", show: true, sort: true, direction: true}],
      disabledCategory: [{header: "Наименование", name: "name", show: true, sort: true, direction: true}],
      socialType: [{header: "Наименование", name: "name", show: true, sort: true, direction: true}],
      group: [{header: "Наименование", name: "name", show: true, sort: true, direction: true}],
      workType: [{header: "Наименование", name: "name", show: true, sort: true, direction: true}],
      newPC: null,
      newDC: null,
      newST: null,
      newG: null,
      newWT: null
    }
  },
  methods: {
    newProductCategory() {
      let object = {name: '', id: 0};
      this.newPC = ({object: object, id: object.id, view: 'edit'});
    },
    newDisabledCategory() {
      let object = {name: '', id: 0};
      this.newDC = ({object: object, id: object.id, view: 'edit'});
    },
    newSocialType() {
      let object = {name: '', id: 0};
      this.newST = ({object: object, id: object.id, view: 'edit'});
    },
    newGroup() {
      let object = {name: '', id: 0};
      this.newG = ({object: object, id: object.id, view: 'edit'});
    },
    newWorkType() {
      let object = {name: '', id: 0};
      this.newWT = ({object: object, id: object.id, view: 'edit'});
    },
  }
}
</script>
<style>
</style>
